function cov_2frsc81lqj() {
  var path = "/app/src/components/currency/index.ts";
  var hash = "b8c25201ea5fff8edc7eafd2cffc38aae974852c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/currency/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b8c25201ea5fff8edc7eafd2cffc38aae974852c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2frsc81lqj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2frsc81lqj();
export { Currency } from './currency';